var React = require('react');

function ArrowThinRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-thin-right"),React.createElement("path",{"d":"M1,0a1,1,0,0,1,.7.3L40.3,43.7a1,1,0,0,1,0,1.3L1.7,88.5A1,1,0,1,1,.3,87.2l38-42.8L.3,1.7A1,1,0,0,1,.3.3Z","fill":"currentColor","key":1})]);
}

ArrowThinRight.defaultProps = {"width":"40.6","height":"88.8","viewBox":"0 0 40.6 88.8"};

module.exports = ArrowThinRight;

ArrowThinRight.default = ArrowThinRight;
